// 3rd
import { Model } from '@vuex-orm/core';

export default class OwnerStatistic extends Model {
    static entity = 'owner-statistics';

    static fields() {
        return {
            id: this.attr(null),
            flat: this.attr(null),
            deep: this.attr(null),
            detailed: this.attr(null),
        }
    }

    // api calls

    // getters
    static getStatistics() {
        return OwnerStatistic.query().first();
    }

    static getYears() {
        const statistics = this.getStatistics();
        return statistics && statistics.deep ? Object.keys(statistics.deep) : [];
    }
}
